/**
 * Copyright © PlanMaster Fogászati Szoftver Kft. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Tamas Neufeld <tamas.neufeld@planmaster3d.com>, 2018
 */


export default {

    namespaced: true,

    state: {
        _debug: true,
        visible: false,
        mobileVisible: true,
        items: [],
        active: null
    },

    getters: {
        items: function(state, getters, rootState, rootGetters) {
            return function() {
                return Array.isArray(state.items) ? state.items : [];
            };
        },
    },

    mutations: {
        /**
         *
         * @param state
         * Use: store.commit('toolbar/toggle');
         */
        toggle: function(state) {
            state.mobileVisible = !state.mobileVisible;
        },

        /**
         *
         * @param state
         * @param params
         * Use: store.commit('toolbar/hide');
         */
        hide: function(state) {
            state.visible = false;
        },

        /**
         *
         * @param state
         * @param params
         * Use: store.commit('toolbar/show');
         */
        show: function(state) {
            state.visible = true;
        },

        /**
         *
         * @param state
         * @param items
         * Use: store.commit('toolbar/setItems',[]);
         */
        setItems: function(state, items) {
            state.items = items;
            //@todo: validate items
        },

        setActive: function (state, key) {
            state.active = key;
        }
    },
};
